
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _404_DVt2oJWfqg8PVIAoQpj6_45s_45rWMrlFRqo_kQi_OCpBoMeta } from "/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/404.vue?macro=true";
import { default as indexzDLi3U__45o_459g4D_45SG4b1ng0cEQ9WNCEoR_452EzxDWbLQMeta } from "/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/index.vue?macro=true";
import { default as JCPayqEWgvEeGislewxxmNIKgfHwzoyPX2pbb1umhVzsSgTwMeta } from "/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/JCPay.vue?macro=true";
import { default as JoinUs8S4ItVprH_WLUuEf_CKHe_45Ks7RK3n_45Zj47cKIcllr34Meta } from "/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/JoinUs.vue?macro=true";
import { default as aboutusBZVtKE46oPDqtY8YGA_INEY_45ZmZegDh5i1_45jGX0seiYMeta } from "/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/aboutus.vue?macro=true";
import { default as contactusoE43jcHEc6983YZjMFyVsERA0tpVFlvuGHJYN6rw1bcMeta } from "/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/contactus.vue?macro=true";
import { default as _91id_93W0YtjRtxgaR21gPmLJVn4ye_ZzYU1wz4povnKhbGYC8Meta } from "/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/home/[id].vue?macro=true";
import { default as appdownloadoHw7tD5ZO8h5_FlL6C0ICiT_lEz8MZKqZoh8XdfZ51IMeta } from "/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/appdownload.vue?macro=true";
import { default as GlobalSearchFaBO2SuSlhNAQPezYetuoVw_9SkbZ6f_45WKQ3JIW6cW0Meta } from "/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/GlobalSearch.vue?macro=true";
import { default as indexoikvjfOuHIio46YOVOt92D9vB8j57k8UgcVQeejxyi0Meta } from "/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/BlackNew/index.vue?macro=true";
import { default as _91id_93_32copyn2DlGethFQ5KygFsY1u2aJbgL7gBnaTyRw9GIOc0dBgMeta } from "/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/home/[id] copy.vue?macro=true";
import { default as indexY3aKUoxFdx0FzDSThXWkWkLqsNZkoJtC6EcycD9b1oUMeta } from "/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/home/case/index.vue?macro=true";
import { default as listI3n9sGPJTyvHb_45aNFFzHX2qZN9cmYU4KeL53PVi_45gN0Meta } from "/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/membership/list.vue?macro=true";
import { default as index0C9sHwMVzHoyXxEOIz6zS2AhGmMbvoWGIXdyinLMaxcMeta } from "/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/resources/index.vue?macro=true";
import { default as blogTagJ1wDCUdqK7xUhgDVeByWOCc8Q8rUFtVaL7J4_45Tb_45dN4Meta } from "/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/resources/blogTag.vue?macro=true";
import { default as BlackListYwaabCrxAdTvej8q2NaveByb8Mba84OPFdRUXbZDslQMeta } from "/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/BlackNew/BlackList.vue?macro=true";
import { default as blogList0mD7MsAQd1lfVZXnrXO88MGe0R0BYt6gSoG8pQF9qIgMeta } from "/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/resources/blogList.vue?macro=true";
import { default as offerj9RXHDZMTd8su0gzmuo6FcJsoK9F43oZeotomHiJFzgMeta } from "/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/inquiry/offer/offer.vue?macro=true";
import { default as baseListHQPz9YOa0C19Q6paEryWNRLmRLXyluePfmmS6Q0KyPgMeta } from "/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/membership/baseList.vue?macro=true";
import { default as benefitsuw8NAZhOjlFnqi505_ZU4V3B_S7vMahH0T607FjYrm4Meta } from "/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/membership/benefits.vue?macro=true";
import { default as sentry_45example_45pagep195BzxSaZyZs36MLWm7EhsKlTSDTZ8_45nWqJhWCUb4cMeta } from "/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/sentry-example-page.vue?macro=true";
import { default as SuspendList7Kw_45m8OPxfe78GRfpOwNM4a5Q_Uz7Ei3XSSfp2m4wzYMeta } from "/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/BlackNew/SuspendList.vue?macro=true";
import { default as indexbIUVnHG5TSdjWmEM4xjf_xsS2uFNGGILqALtULR75fYMeta } from "/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/knowledge/News/index.vue?macro=true";
import { default as blogDetailQcCTQZj15_45MknVe5cd1moigaET0_450sou7xpVnQY6YnkMeta } from "/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/resources/blogDetail.vue?macro=true";
import { default as detailUNiTkM2RKwSQIXzaX24bXS_sN56eoQ4VuSrPUV_451RvgMeta } from "/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/BlackNew/Black/detail.vue?macro=true";
import { default as detail9d5ehjis915J48VgqSlVCbxdQd5mDmkCnuPuot6qjUAMeta } from "/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/knowledge/News/detail.vue?macro=true";
import { default as ruleRegularWTNia5iasyGJdt_9OJeMGMBdOmh3gUORjgJgaj7IG_45YMeta } from "/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/inquiry/src/ruleRegular.ts?macro=true";
import { default as constantrvXbHm4t52sPkFom0kLZfIVGsVzTZNv_40fRICgW_45_45AMeta } from "/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/knowledge/News/constant.ts?macro=true";
import { default as logisticsnewsyWucx_Yx4Qufk5Gy0Z7pqzkX40GT54M5KwRSp3kFyWwMeta } from "/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/knowledge/logisticsnews.vue?macro=true";
import { default as introduction3EsBhwpxg7d2I1IDPnxzRgfqCm1xa9lLtzBGrq9dVB0Meta } from "/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/membership/introduction.vue?macro=true";
import { default as indexH2pm_45RChaDtmh4R8zYss5TuhZKffB3Opt2WtI76yE0QMeta } from "/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/inquiry/checkEmail/index.vue?macro=true";
import { default as eliteuB38Jl_455i0_TXjujQl9MRyU2XaEwzOAqZDmvTqKdUqEMeta } from "/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/membership/general/elite.vue?macro=true";
import { default as risingN3dDDeRZLGTKfOU2zpDwqqqWpl7BvGeh3kHT9oA2BysMeta } from "/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/membership/general/rising.vue?macro=true";
import { default as offerSuccess0VK4lKBmGx36KqOuCD0GcQXzHjFeUBSZPmB7t2sHNFsMeta } from "/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/inquiry/offer/offerSuccess.vue?macro=true";
import { default as premiumloeRz7yojYD_45pSAbCgoCrSGpHRQ2jyHlcW0y_45YKzFBkMeta } from "/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/membership/general/premium.vue?macro=true";
import { default as vendorOwN0ZV4EjQ_0rcsuCcqb8UutBRbmlh1WYQ6ozLZXPFMMeta } from "/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/membership/supplier/vendor.vue?macro=true";
import { default as riskCaseBXnw823rsKeH1Cf_45PUDIR514FlMTTDHBdSLvjVHJ0z0Meta } from "/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/BlackNew/Prevention/riskCase.vue?macro=true";
import { default as railwayGeyfmvAhP1h7a8lOKrhBWuR3_w0I97hdwb1tvHYF4rIMeta } from "/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/membership/specialty/railway.vue?macro=true";
import { default as commerce9FP4wEvDNBji1GSbFffhIs2mHTPLp6ldlxC_45NycCs_45YMeta } from "/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/membership/specialty/commerce.vue?macro=true";
import { default as projectsk0Ng0CDCYJDChNTJrvKRVQ_KpLtryWp5J9ZPlMLUFBkMeta } from "/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/membership/specialty/projects.vue?macro=true";
import { default as newsItemud6N327tf72w0tJ21JQWQ2FQ5ugIaDP45sfURmi4b0cMeta } from "/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/resources/components/newsItem.vue?macro=true";
import { default as CaseDetailckLjevlMTRzyBz__D12K2hyb4pnWdKS109VQRgkXnpkMeta } from "/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/BlackNew/Prevention/CaseDetail.vue?macro=true";
import { default as riskNoticeDAhaprLhbBmQdO3D5VXcLRcHC_45ELArVy7fxVrxx5p0cMeta } from "/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/BlackNew/Prevention/riskNotice.vue?macro=true";
import { default as dangerousEDYKmq8aenJA1hA0Rc6au4k99B31Y9aeO9Vavm4vmgsMeta } from "/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/membership/specialty/dangerous.vue?macro=true";
import { default as riskSharingz12a62EUJBccVOJPCNbG9L3N3JfHS0QKJ2K_oFtvpR4Meta } from "/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/BlackNew/Prevention/riskSharing.vue?macro=true";
import { default as blackListJYSB0NxuwXLVO2GQe_45CUMttxBErc7A3zO5NijLKHaowMeta } from "/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/membership/tools/risk/blackList.vue?macro=true";
import { default as riskStandardsTiD8rQhyRF7cZxer6Sh8BzQCPdkRug34FVNP4yKm8yAMeta } from "/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/BlackNew/Assurance/riskStandards.vue?macro=true";
import { default as NoticeDetail3_45ODV7jhl3LqFFMxwcn0eoCnQ1T7KB3R_45hBMzNFKbt0Meta } from "/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/BlackNew/Prevention/NoticeDetail.vue?macro=true";
import { default as SharingDetailRs2aiWRuKEj8epjRj3kD39sbE0Ekqpt7BVp6Z5mpX_45UMeta } from "/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/BlackNew/Prevention/SharingDetail.vue?macro=true";
import { default as bindEmailIlrHoubLuUvY0saDvmrbY5AgBNKYcPLcER3Km29_6GkMeta } from "/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/inquiry/offer/components/bindEmail.vue?macro=true";
import { default as processbfbQKP5dVfmkV2qW7_45OG5SM00DF0lCduCTUkpEzboQoMeta } from "/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/membership/tools/assurance/process.vue?macro=true";
import { default as caseXjbxS9RsxlTwwLqmYUfi27WS8r_45w_T3SbLzY_72kO30Meta } from "/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/membership/tools/riskPrevention/case.vue?macro=true";
import { default as riskAssuranceTopicMxjUCgzDPlPd0m9_Z7_no01bvVUAHtCmF35ykLdvnGsMeta } from "/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/BlackNew/Assurance/riskAssuranceTopic.vue?macro=true";
import { default as messageDialogfiUMgJ9_2qtA1hXuEImLV6tICCz5sHnHcV549HcNho0Meta } from "/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/inquiry/offer/components/messageDialog.vue?macro=true";
import { default as AssuranceTopicDetailvYTtx9OBpmFoyY4LpKE6vS3XSXts_45Z2Yg1crGM2S3NcMeta } from "/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/BlackNew/Assurance/AssuranceTopicDetail.vue?macro=true";
import { default as riskAssuranceProcess0mfeiOz8aiSuxvWgsUFzJ0PDMAEh2LmEPNDysCMgam4Meta } from "/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/BlackNew/Assurance/riskAssuranceProcess.vue?macro=true";
import { default as riskAssuranceQuestionCRqOdhQXRFXsUzNPKgVBU6rtS16CqZER6X1B_45RztCvsMeta } from "/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/BlackNew/Assurance/riskAssuranceQuestion.vue?macro=true";
import { default as jumpQueueDialogLptppHizfNpRVOc8n36aiMxH5wj2pERzryjUFqFB_rsMeta } from "/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/inquiry/offer/components/jumpQueueDialog.vue?macro=true";
import { default as AssuranceProcessDetail4orbbw3ZA5Fsj8fG2Tc9GS3mDuJDtT3Eo0uZEfHYxosMeta } from "/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/BlackNew/Assurance/AssuranceProcessDetail.vue?macro=true";
import { default as AssuranceQuestionDetailF_45x5J_R9yMTIid4TecRux6lRGXSJTuTY_ztJ_1pWQCAMeta } from "/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/BlackNew/Assurance/AssuranceQuestionDetail.vue?macro=true";
export default [
  {
    name: "404",
    path: "/404",
    component: () => import("/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/404.vue")
  },
  {
    name: "Home",
    path: "/",
    meta: indexzDLi3U__45o_459g4D_45SG4b1ng0cEQ9WNCEoR_452EzxDWbLQMeta || {},
    component: () => import("/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/index.vue")
  },
  {
    name: "JCPay",
    path: "/JCPay",
    component: () => import("/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/JCPay.vue")
  },
  {
    name: "JoinUs",
    path: "/JoinUs",
    meta: JoinUs8S4ItVprH_WLUuEf_CKHe_45Ks7RK3n_45Zj47cKIcllr34Meta || {},
    component: () => import("/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/JoinUs.vue")
  },
  {
    name: "aboutus",
    path: "/aboutus",
    component: () => import("/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/aboutus.vue")
  },
  {
    name: "contactus",
    path: "/contactus",
    component: () => import("/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/contactus.vue")
  },
  {
    name: "home-id",
    path: "/home/:id()",
    component: () => import("/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/home/[id].vue")
  },
  {
    name: "appdownload",
    path: "/appdownload",
    component: () => import("/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/appdownload.vue")
  },
  {
    name: "GlobalSearch",
    path: "/GlobalSearch",
    component: () => import("/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/GlobalSearch.vue")
  },
  {
    name: "BlackNew",
    path: "/BlackNew",
    component: () => import("/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/BlackNew/index.vue")
  },
  {
    name: "shopHome",
    path: "/home/:id()%20copy",
    meta: _91id_93_32copyn2DlGethFQ5KygFsY1u2aJbgL7gBnaTyRw9GIOc0dBgMeta || {},
    component: () => import("/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/home/[id] copy.vue")
  },
  {
    name: "home-case",
    path: "/home/case",
    component: () => import("/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/home/case/index.vue")
  },
  {
    name: "membership-list",
    path: "/membership/list",
    component: () => import("/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/membership/list.vue")
  },
  {
    name: "resources",
    path: "/resources",
    component: () => import("/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/resources/index.vue")
  },
  {
    name: "resources-blogTag",
    path: "/resources/blogTag",
    component: () => import("/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/resources/blogTag.vue")
  },
  {
    name: "BlackNew-BlackList",
    path: "/BlackNew/BlackList",
    component: () => import("/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/BlackNew/BlackList.vue")
  },
  {
    name: "resources-blogList",
    path: "/resources/blogList",
    component: () => import("/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/resources/blogList.vue")
  },
  {
    name: "inquiry-offer-offer",
    path: "/inquiry/offer/offer",
    component: () => import("/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/inquiry/offer/offer.vue")
  },
  {
    name: "membership-baseList",
    path: "/membership/baseList",
    component: () => import("/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/membership/baseList.vue")
  },
  {
    name: "BenefitsOverview",
    path: "/membership/benefits",
    meta: benefitsuw8NAZhOjlFnqi505_ZU4V3B_S7vMahH0T607FjYrm4Meta || {},
    component: () => import("/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/membership/benefits.vue")
  },
  {
    name: "sentry-example-page",
    path: "/sentry-example-page",
    component: () => import("/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/sentry-example-page.vue")
  },
  {
    name: "BlackNew-SuspendList",
    path: "/BlackNew/SuspendList",
    component: () => import("/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/BlackNew/SuspendList.vue")
  },
  {
    name: "knowledge-News",
    path: "/knowledge/News",
    component: () => import("/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/knowledge/News/index.vue")
  },
  {
    name: "resources-blogDetail",
    path: "/resources/blogDetail",
    component: () => import("/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/resources/blogDetail.vue")
  },
  {
    name: "BlackNew-Black-detail",
    path: "/BlackNew/Black/detail",
    component: () => import("/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/BlackNew/Black/detail.vue")
  },
  {
    name: "knowledge-News-detail",
    path: "/knowledge/News/detail",
    component: () => import("/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/knowledge/News/detail.vue")
  },
  {
    name: "inquiry-src-ruleRegular",
    path: "/inquiry/src/ruleRegular",
    component: () => import("/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/inquiry/src/ruleRegular.ts")
  },
  {
    name: "knowledge-News-constant",
    path: "/knowledge/News/constant",
    component: () => import("/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/knowledge/News/constant.ts")
  },
  {
    name: "knowledge-logisticsnews",
    path: "/knowledge/logisticsnews",
    component: () => import("/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/knowledge/logisticsnews.vue")
  },
  {
    name: "membership-introduction",
    path: "/membership/introduction",
    component: () => import("/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/membership/introduction.vue")
  },
  {
    name: "inquiry-checkEmail",
    path: "/inquiry/checkEmail",
    component: () => import("/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/inquiry/checkEmail/index.vue")
  },
  {
    name: "membershipJCTransElite",
    path: "/membership/general/elite",
    meta: eliteuB38Jl_455i0_TXjujQl9MRyU2XaEwzOAqZDmvTqKdUqEMeta || {},
    component: () => import("/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/membership/general/elite.vue")
  },
  {
    name: "membershipJCTransRising",
    path: "/membership/general/rising",
    meta: risingN3dDDeRZLGTKfOU2zpDwqqqWpl7BvGeh3kHT9oA2BysMeta || {},
    component: () => import("/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/membership/general/rising.vue")
  },
  {
    name: "inquiry-offer-offerSuccess",
    path: "/inquiry/offer/offerSuccess",
    component: () => import("/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/inquiry/offer/offerSuccess.vue")
  },
  {
    name: "membershipJCTransPremium",
    path: "/membership/general/premium",
    meta: premiumloeRz7yojYD_45pSAbCgoCrSGpHRQ2jyHlcW0y_45YKzFBkMeta || {},
    component: () => import("/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/membership/general/premium.vue")
  },
  {
    name: "membershipJCTransVendor",
    path: "/membership/supplier/vendor",
    meta: vendorOwN0ZV4EjQ_0rcsuCcqb8UutBRbmlh1WYQ6ozLZXPFMMeta || {},
    component: () => import("/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/membership/supplier/vendor.vue")
  },
  {
    name: "BlackNew-Prevention-riskCase",
    path: "/BlackNew/Prevention/riskCase",
    component: () => import("/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/BlackNew/Prevention/riskCase.vue")
  },
  {
    name: "membershipJCTransRailwayAbout",
    path: "/membership/specialty/railway",
    meta: railwayGeyfmvAhP1h7a8lOKrhBWuR3_w0I97hdwb1tvHYF4rIMeta || {},
    component: () => import("/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/membership/specialty/railway.vue")
  },
  {
    name: "membershipJCTransECommerceAbout",
    path: "/membership/specialty/commerce",
    meta: commerce9FP4wEvDNBji1GSbFffhIs2mHTPLp6ldlxC_45NycCs_45YMeta || {},
    component: () => import("/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/membership/specialty/commerce.vue")
  },
  {
    name: "membershipJCTransProjectsAbout",
    path: "/membership/specialty/projects",
    meta: projectsk0Ng0CDCYJDChNTJrvKRVQ_KpLtryWp5J9ZPlMLUFBkMeta || {},
    component: () => import("/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/membership/specialty/projects.vue")
  },
  {
    name: "resources-components-newsItem",
    path: "/resources/components/newsItem",
    component: () => import("/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/resources/components/newsItem.vue")
  },
  {
    name: "BlackNew-Prevention-CaseDetail",
    path: "/BlackNew/Prevention/CaseDetail",
    component: () => import("/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/BlackNew/Prevention/CaseDetail.vue")
  },
  {
    name: "BlackNew-Prevention-riskNotice",
    path: "/BlackNew/Prevention/riskNotice",
    component: () => import("/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/BlackNew/Prevention/riskNotice.vue")
  },
  {
    name: "membershipJCTransDangerousGoodsAbout",
    path: "/membership/specialty/dangerous",
    meta: dangerousEDYKmq8aenJA1hA0Rc6au4k99B31Y9aeO9Vavm4vmgsMeta || {},
    component: () => import("/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/membership/specialty/dangerous.vue")
  },
  {
    name: "BlackNew-Prevention-riskSharing",
    path: "/BlackNew/Prevention/riskSharing",
    component: () => import("/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/BlackNew/Prevention/riskSharing.vue")
  },
  {
    name: "membership-tools-risk-blackList",
    path: "/membership/tools/risk/blackList",
    component: () => import("/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/membership/tools/risk/blackList.vue")
  },
  {
    name: "BlackNew-Assurance-riskStandards",
    path: "/BlackNew/Assurance/riskStandards",
    component: () => import("/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/BlackNew/Assurance/riskStandards.vue")
  },
  {
    name: "BlackNew-Prevention-NoticeDetail",
    path: "/BlackNew/Prevention/NoticeDetail",
    component: () => import("/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/BlackNew/Prevention/NoticeDetail.vue")
  },
  {
    name: "BlackNew-Prevention-SharingDetail",
    path: "/BlackNew/Prevention/SharingDetail",
    component: () => import("/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/BlackNew/Prevention/SharingDetail.vue")
  },
  {
    name: "inquiry-offer-components-bindEmail",
    path: "/inquiry/offer/components/bindEmail",
    component: () => import("/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/inquiry/offer/components/bindEmail.vue")
  },
  {
    name: "membership-tools-assurance-process",
    path: "/membership/tools/assurance/process",
    component: () => import("/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/membership/tools/assurance/process.vue")
  },
  {
    name: "membership-tools-riskPrevention-case",
    path: "/membership/tools/riskPrevention/case",
    component: () => import("/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/membership/tools/riskPrevention/case.vue")
  },
  {
    name: "BlackNew-Assurance-riskAssuranceTopic",
    path: "/BlackNew/Assurance/riskAssuranceTopic",
    component: () => import("/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/BlackNew/Assurance/riskAssuranceTopic.vue")
  },
  {
    name: "inquiry-offer-components-messageDialog",
    path: "/inquiry/offer/components/messageDialog",
    component: () => import("/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/inquiry/offer/components/messageDialog.vue")
  },
  {
    name: "BlackNew-Assurance-AssuranceTopicDetail",
    path: "/BlackNew/Assurance/AssuranceTopicDetail",
    component: () => import("/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/BlackNew/Assurance/AssuranceTopicDetail.vue")
  },
  {
    name: "BlackNew-Assurance-riskAssuranceProcess",
    path: "/BlackNew/Assurance/riskAssuranceProcess",
    component: () => import("/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/BlackNew/Assurance/riskAssuranceProcess.vue")
  },
  {
    name: "BlackNew-Assurance-riskAssuranceQuestion",
    path: "/BlackNew/Assurance/riskAssuranceQuestion",
    component: () => import("/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/BlackNew/Assurance/riskAssuranceQuestion.vue")
  },
  {
    name: "inquiry-offer-components-jumpQueueDialog",
    path: "/inquiry/offer/components/jumpQueueDialog",
    component: () => import("/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/inquiry/offer/components/jumpQueueDialog.vue")
  },
  {
    name: "BlackNew-Assurance-AssuranceProcessDetail",
    path: "/BlackNew/Assurance/AssuranceProcessDetail",
    component: () => import("/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/BlackNew/Assurance/AssuranceProcessDetail.vue")
  },
  {
    name: "BlackNew-Assurance-AssuranceQuestionDetail",
    path: "/BlackNew/Assurance/AssuranceQuestionDetail",
    component: () => import("/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/pages/BlackNew/Assurance/AssuranceQuestionDetail.vue")
  }
]